var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.activesessions.data,"options":_vm.options,"server-items-length":_vm.activesessions.total,"footer-props":{
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100],
    },"loading":_vm.isLoading,"no-data-text":"Pas de session active sur ce portail."},on:{"update:options":function($event){_vm.options=$event},"click:row":function (item) { return _vm.$router.push({
          name: 'cartes-details',
          params: { id: item.card.id },
        }); }},scopedSlots:_vm._u([{key:"item.sessionStartsAt",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getInternationalDate(item.sessionStartsAt))+" ")]}},{key:"item.lastUpdatedAt",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getInternationalDate(item.lastUpdatedAt))+" ")]}},{key:"item.volumUp",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBytes(item.volumUp) + " / " + _vm.formatBytes(item.volumDown))+" ")]}},{key:"item.debitDownloadBps",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBytes(item.debitUploadBps) + " / " + _vm.formatBytes(item.debitDownloadBps))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }